import { loadMathJax } from '../../infra/ui/math-rendering/src'

// Initialize once before this module is ready, keeping React and static rendering synchronous.
const engine = await loadMathJax()

export function MathFormula({
  blockId,
  displayMode,
  source,
}: {
  blockId?: string
  displayMode: boolean
  source: string
}) {
  const { svg } = engine.convert(source, displayMode)
  return displayMode ? (
    <div
      style={{ display: 'block', margin: '1em 0', textAlign: 'center' }}
      data-content-block-id={blockId}
      aria-label={source}
      role="math"
      data-testid="math-formula"
      data-math="block"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  ) : (
    <span
      aria-label={source}
      role="math"
      data-testid="math-formula"
      data-math="inline"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}
